import { render, staticRenderFns } from "./MultiSelectArcheType.vue?vue&type=template&id=13b41a96&"
import script from "./MultiSelectArcheType.vue?vue&type=script&lang=js&"
export * from "./MultiSelectArcheType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports